import * as React from 'react';
import './PageComponent.scss';

export const PageRenderError = () => {
    
    return <div className="error-content">
            <i className="la la-exclamation-triangle" />
                <h3>An error occurrred trying to load this page.  
                    Please try refreshing your browser and trying again. <br/>
                    If you continue to receive this error and need help, 
                    please contact <a href="mailto: support@codagami.com">support</a>.</h3>
            </div>;
};
